import McsCustomTabs from "./mcs-custom-tabs.component";

export default McsCustomTabs;
